const DateTypes = Object.freeze({
  Last30Days: -30,
  LastDay: -1,
  Last7Days: -7,
  Last90Days: -90,
  Today: 0,
  Next7Days: 7,
  Custom: "null",
});

export const DateFormat = "yyyy-MM-dd";

export default DateTypes;
